import axios from 'axios';
import { ensureCsrfToken } from '../../../lib/csrf';

const BASE = '/api/digital-risk/investment-proposals/';
const config = { withCredentials: true };
export async function listInvestmentProposals() { return (await axios.get(BASE, config)).data; }
export async function retrieveInvestmentProposal(reference) { return (await axios.get(`${BASE}${reference}/`, config)).data; }
export async function fetchInvestmentProposalPlanningContext(cycleReference) { return (await axios.get(`${BASE}planning-context/`, { ...config, params: cycleReference ? { planning_cycle_reference: cycleReference } : {} })).data; }
export async function persistManagementInvestmentRequest(amount, currency, acceptedEvidenceReference) {
  const csrf = await ensureCsrfToken();
  const payload = { amount, currency };
  if (acceptedEvidenceReference) payload.accepted_evidence_reference = acceptedEvidenceReference;
  return (await axios.post(`${BASE}management-request/`, payload, {
    withCredentials: true, headers: { 'X-CSRFToken': csrf },
  })).data;
}
async function writeInvestmentProposal(payload, reference) {
  const csrf = await ensureCsrfToken();
  const request = { withCredentials: true, headers: { 'X-CSRFToken': csrf } };
  return (reference ? await axios.patch(`${BASE}${reference}/`, payload, request) : await axios.post(BASE, payload, request)).data;
}
export const createInvestmentProposal = (payload) => writeInvestmentProposal(payload);
export const updateInvestmentProposal = (reference, payload) => writeInvestmentProposal(payload, reference);
export async function createExpectedOutcome(reference, payload) {
  const csrf = await ensureCsrfToken();
  return (await axios.post(`${BASE}${reference}/expected-outcomes/`, payload, { withCredentials: true, headers: { 'X-CSRFToken': csrf } })).data;
}
export async function updateExpectedOutcome(reference, outcomeReference, payload) {
  const csrf = await ensureCsrfToken();
  return (await axios.patch(`${BASE}${reference}/expected-outcomes/${outcomeReference}/`, payload, { withCredentials: true, headers: { 'X-CSRFToken': csrf } })).data;
}
export async function deleteExpectedOutcome(reference, outcomeReference) {
  const csrf = await ensureCsrfToken();
  await axios.delete(`${BASE}${reference}/expected-outcomes/${outcomeReference}/`, { withCredentials: true, headers: { 'X-CSRFToken': csrf } });
}
async function writeSuccessCriterion(reference, outcomeReference, payload, update = false) {
  const csrf = await ensureCsrfToken();
  const url = `${BASE}${reference}/expected-outcomes/${outcomeReference}/success-criterion/`;
  const request = { withCredentials: true, headers: { 'X-CSRFToken': csrf } };
  return (update ? await axios.patch(url, payload, request) : await axios.post(url, payload, request)).data;
}
export const createSuccessCriterion = (reference, outcomeReference, payload) => writeSuccessCriterion(reference, outcomeReference, payload);
export const updateSuccessCriterion = (reference, outcomeReference, payload) => writeSuccessCriterion(reference, outcomeReference, payload, true);
export async function deleteSuccessCriterion(reference, outcomeReference) {
  const csrf = await ensureCsrfToken();
  await axios.delete(`${BASE}${reference}/expected-outcomes/${outcomeReference}/success-criterion/`, { withCredentials: true, headers: { 'X-CSRFToken': csrf } });
}

export async function submitInvestmentProposal(reference) {
  const csrf = await ensureCsrfToken();
  return (await axios.post(`${BASE}${reference}/submit/`, {}, { withCredentials: true, headers: { 'X-CSRFToken': csrf } })).data;
}
